import { RectPickerBase } from "../common/rect-picker-base";

export class DefaultCanvasLottiePicker extends RectPickerBase {
    constructor(canvasRenderer) {
        super(), this.canvasRenderer = canvasRenderer;
    }
}
//# sourceMappingURL=lottie-picker.js.map
